import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { fetchData, updateData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { IconButton } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import FeedIcon from '@mui/icons-material/Feed';
import Select from 'react-select'; // Import react-select
import CopyrightIcon from '@mui/icons-material/Copyright';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import CreateIcon from '@mui/icons-material/Create';
import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { Tooltip } from '@mui/material';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import Modal from '@mui/material/Modal';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useLocation, Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";


function SaleHSNCReport() {
    const { isAuthenticated, companyId, branchId, permissions, token, username, logout } = useAuth();
    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        //fetchTableData();

    }, [isAuthenticated, companyId, branchId, permissions, token, logout]);
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isFocused, setIsFocused] = useState(false);

    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');
    const hasReadReportPermission = permissions.includes('Read Reports');


    // Function to format date as dd/mm/yyyy
    const getCurrentDate = () => {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero, months are 0-indexed
        const year = today.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        return new Date(dateString).toLocaleDateString('en-GB', options);
    };

    const [totalcls, setTotalcls] = useState(0);
    useEffect(() => {
        let totalcls = 0;

        data.forEach(item => {
            totalcls += item.amount;

        });
        setTotalcls(totalcls);
    }, [data]);

    const [hsncType, sethsnc] = useState("1");
    const handlesethsncTypeChange = (event) => {
        sethsnc(event.target.value);
    };

    const [loading, setLoading] = useState(false);

    const fetchTableData = async () => {
        if (hasReadReportPermission) {
            setData([]);
            setLoading(true);
            try {
                //const response = await fetchData('ReportAPI', `/SaleHSNWiseDetails/${fromDate}/${toDate}/${companyId}/${hsncType}`, token);
                const response = await fetchData('ReportApi', `/SaleHSNWiseDetails/${fromDate}/${toDate}/${companyId}/${branchId}/${hsncType}`, token);
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
            } catch (error) {
                console.error('Error fetching Sale HSN Wise Details:', error);
            }
            finally {
                setLoading(false); // Hide loading screen
            }
        }
    };



    const handleExportExcel = async () => {
        if (!data || data.length === 0) {
            alert("No data to export!");
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Sale HSN Report");

        let typeLabel;
        if (hsncType === "1") {
            typeLabel = "B to B";
        } else if (hsncType === "2") {
            typeLabel = "B to C";
        } else {
            typeLabel = "All (B to B & B to C)";
        }

        const now = new Date();
        const formattedDateTime = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`;
        const headerCaption = `${typeLabel} | From: ${formatDate(fromDate)} | To: ${formatDate(toDate)} | Generated on: ${formattedDateTime} by ${username}`;

        // ---- Title Row ----
        worksheet.addRow([headerCaption]);
        worksheet.mergeCells("A1:I1");
        worksheet.getCell("A1").font = { bold: true, size: 13 };
        worksheet.getCell("A1").alignment = { horizontal: "center" };
        worksheet.addRow([]);

        // ---- Header Row ----
        const headerRow = worksheet.addRow([
            "Sl.No",
            "HSN Code",
            "Quantity",
            "GST Rate",
            "Taxable Amount",
            "CGST Amount",
            "SGST Amount",
            "IGST Amount",
            "Total Amount",
        ]);

        // Header styling
        headerRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "4472C4" }, // Excel blue header
            };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" },
            };
            cell.alignment = { horizontal: "center" };
        });

        // ---- Data Rows ----
        data.forEach((item, index) => {
            const row = worksheet.addRow([
                index + 1,
                item.HSNCode || "",
                Number(item.Quantity || 0),
                Number(item.GSTRate || 0),
                Number(item.TaxableAmount || 0),
                Number(item.CGSTAmount || 0),
                Number(item.SGSTAmount || 0),
                Number(item.IGSTAmount || 0),
                Number(item.TotalAmount || 0),
            ]);

            row.eachCell((cell, colNumber) => {
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" },
                };
                if (colNumber >= 5 && colNumber <= 9) {
                    cell.alignment = { horizontal: "right" };
                    cell.numFmt = "#,##0.00";
                }
            });
        });

        // ---- Totals ----
        const totalTaxable = data.reduce((sum, row) => sum + Number(row.TaxableAmount || 0), 0);
        const totalCGST = data.reduce((sum, row) => sum + Number(row.CGSTAmount || 0), 0);
        const totalSGST = data.reduce((sum, row) => sum + Number(row.SGSTAmount || 0), 0);
        const totalIGST = data.reduce((sum, row) => sum + Number(row.IGSTAmount || 0), 0);
        const totalAmount = data.reduce((sum, row) => sum + Number(row.TotalAmount || 0), 0);

        const totalRow = worksheet.addRow([
            "Total",
            "",
            "",
            "",
            totalTaxable,
            totalCGST,
            totalSGST,
            totalIGST,
            totalAmount,
        ]);

        totalRow.eachCell((cell, colNumber) => {
            cell.font = { bold: true };
            cell.border = {
                top: { style: "medium" },
                left: { style: "thin" },
                bottom: { style: "medium" },
                right: { style: "thin" },
            };
            if (colNumber >= 5 && colNumber <= 9) {
                cell.alignment = { horizontal: "right" };
                cell.numFmt = "#,##0.00";
            }
            if (colNumber < 5) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FFF2CC" },
                };
            }
        });

        // ---- Column Widths ----
        const widths = [8, 15, 10, 10, 15, 15, 15, 15, 15];
        widths.forEach((width, i) => {
            worksheet.getColumn(i + 1).width = width;
        });

        // ---- Save File ----
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `SaleHSNReport_${typeLabel}_${formatDate(toDate)}.xlsx`);
    };



    const cellStyle = {
        borderBottom: '1px solid black',
        color: 'white',
        fontWeight: 'bolder',
        padding: '7px',
        textAlign: 'left',
        fontSize: '12px',
    };

    return (

        <div className="w-full  mx-auto" style={{ width: '95%', marginTop: '10px' }}>
            <h6
                className="block uppercase tracking-wide text-black productHead flex-grow linkcolor"
                style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}
            >
                {hsncType === "1" ? "B to B" : (hsncType === "2" ? "B to C" : "All  (B to B & B to C)")}
            </h6>

            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <div>
                        <CircularProgress style={{ color: 'white' }} />
                        <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
                    </div>
                </div>
            )}
            <div style={{
                width: '100%',
                marginBottom: '2',
                display: 'flex',
                flexWrap: 'nowrap',
                justifyContent: 'flex-end',
                alignItems: 'center',
                paddingRight: '20px',
                position: 'relative',
                marginTop: '-2%'
            }}>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '10px', marginLeft: '10px', flexWrap: 'wrap' }}>

                    {/* From Date Field */}
                    <div style={{ display: 'flex', alignItems: 'center', paddingRight: '8px', marginBottom: '10px' }}>
                        <label
                            style={{ color: 'Black', fontSize: '13px', fontWeight: 'bold', marginRight: '8px', fontFamily: 'monospace' }}
                            htmlFor="fromDate"
                        >
                            From
                        </label>
                        <input
                            id="fromDate"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date"
                            value={fromDate}
                            onChange={handleFromDateChange}
                            style={{ fontSize: '12.5px' }}
                        />
                    </div>

                    {/* To Date Field */}
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px', marginBottom: '10px' }}>
                        <label
                            style={{ color: 'Black', fontSize: '13px', fontWeight: 'bold', marginRight: '8px', fontFamily: 'monospace' }}
                            htmlFor="toDate"
                        >
                            To
                        </label>
                        <input
                            id="toDate"
                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                            type="date"
                            value={toDate}
                            onChange={handleToDateChange}
                            style={{ fontSize: '12.5px' }}
                        />
                    </div>


                    <div className="flex justify-end items-center">
                        <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="hsncType"
                                value="1"
                                checked={hsncType === "1"} // This will check the "Creditor" radio button by default
                                onChange={handlesethsncTypeChange}
                            />
                            <span style={{ color: 'blue', fontSize: '12px' }}>B to B</span>
                        </label>
                        <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="hsncType"
                                value="2"
                                checked={hsncType === "2"} // This will check the "Debitor" radio button if it's selected
                                onChange={handlesethsncTypeChange}
                            />
                            <span style={{ color: 'brown', fontSize: '12px' }}>B to C</span>
                        </label>
                        <label className="block uppercase tracking-wide text-gray-700 font-bold mr-0" style={{ marginLeft: '12px' }}>
                            <input
                                type="radio"
                                name="hsncType"
                                value="3"
                                checked={hsncType === "3"} // This will check the "Debitor" radio button if it's selected
                                onChange={handlesethsncTypeChange}
                            />
                            <span style={{ color: 'brown', fontSize: '12px' }}>All</span>
                        </label>
                    </div>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={fetchTableData}
                        className="linkcolor"
                    >
                        <IconButton onClick={fetchTableData}>
                            {/* <RefreshIcon style={{ color: 'brown' }} /> */}
                        </IconButton>
                        <span style={{ color: 'brown', fontWeight: 'bolder', fontSize: '12px' }}>Refresh</span>
                    </Button>
                    <Button
                        style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '10px' }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <IconButton onClick={handleExportExcel}>
                            {/* <FeedIcon style={{ color: 'darkgreen' }} /> */}
                        </IconButton>
                        <span style={{ color: 'darkgreen', fontWeight: 'bolder', fontSize: '12px' }}>Excel</span>
                    </Button>
                </div>
                {/* Watermark at the bottom-right corner */}


            </div>

            <div className="watermark" style={{ position: 'absolute', bottom: '10px', right: '20px' }}>
                <CopyrightIcon />
                <b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>


            <div className="w-full mb-5 flex" style={{ maxHeight: "550px", overflowY: "auto", marginTop: "7px" }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {["Sl.No", "HSN Code", "Quantity", "GST Rate", "Taxable", "CGST", "SGST", "IGST", "Total"].map((head, i) => (
                                    <TableCell
                                        key={i}
                                        sx={{
                                            backgroundColor: "#27445D",
                                            color: "whitesmoke",
                                            fontWeight: "bolder",
                                            textTransform: "uppercase",
                                            fontSize: "11px",
                                            padding: "3px",

                                        }}
                                    >
                                        {head}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>

                        <TableBody sx={{ backgroundColor: 'white' }}>
                            {data.length > 0 ? (
                                data.map((data, index) => (
                                    <TableRow key={data.id || index}>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '12px' }}>{index + 1}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '12px' }}>{data.HSNCode}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '12px' }}>{data.Quantity}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'left', fontSize: '12px' }}>{data.GSTRate}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '12px' }}>{data.TaxableAmount}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '12px' }}>{data.CGSTAmount}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '12px' }}>{data.SGSTAmount}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '12px' }}>{data.IGSTAmount}</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid black', borderRight: '1px solid grey', color: 'black', fontWeight: 'bolder', padding: '3px', textAlign: 'right', fontSize: '12px' }}>{data.TotalAmount}</TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={9} sx={{ textAlign: 'center', padding: '16px', color: 'black' }}>
                                        No data available
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>

                        {data.length > 0 && (
                            <TableFooter sx={{ backgroundColor: '#183B4E' }}>
                                <TableRow>
                                    <TableCell sx={{ ...cellStyle, fontWeight: 'bold' }} colSpan={4}>
                                        Total
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        {data.reduce((sum, row) => sum + Number(row.TaxableAmount || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        {data.reduce((sum, row) => sum + Number(row.CGSTAmount || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        {data.reduce((sum, row) => sum + Number(row.SGSTAmount || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        {data.reduce((sum, row) => sum + Number(row.IGSTAmount || 0), 0).toFixed(2)}
                                    </TableCell>
                                    <TableCell sx={{ ...cellStyle, textAlign: 'right', fontWeight: 'bold' }}>
                                        {data.reduce((sum, row) => sum + Number(row.TotalAmount || 0), 0).toFixed(2)}
                                    </TableCell>
                                </TableRow>
                            </TableFooter>
                        )}
                    </Table>
                </TableContainer>

            </div>

        </div >
    );
}

export default SaleHSNCReport;
